import { updateRatesEnterpriseRequest } from "../../data/ratesEnterpriseApi";
import { validateTarifaEnterprisePayload } from "../validator/validateTarifaEnterprisePayload";

export async function updateTarifaEnterpriseUseCase(payload) {
  if (!payload?.id) {
    throw new Error("El id de la tarifa empresarial es obligatorio.");
  }

  const error = validateTarifaEnterprisePayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await updateRatesEnterpriseRequest(payload);
}
